  /* serpentine */
var Paths = 
{
  Sine: function( wavelength, amplitude )
  {
    return function(start, end) 
    {
      var sx = start.x;
      var sy = start.y;
      var dx = end.x - sx;
      var dy = end.y - sy;
      var distance = Math.sqrt( dx * dx + dy * dy );
      var invdistance = 1.0 / distance;

      return function(out, delta) 
      {
        var v = delta * distance;
        var x = v / wavelength * Math.PI;
        var y = Math.sin( x ) * amplitude;
        var nx = dy * invdistance;
        var ny = -dx * invdistance;

        out.x = (dx * delta + sx) + (nx * y);
        out.y = (dy * delta + sy) + (ny * y);

        return out;
      };
    };
  },

  Linear: function(start, end) 
  {
    var sx = start.x;
    var sy = start.y;
    var dx = end.x - sx;
    var dy = end.y - sy;

    return function(out, delta) 
    {
      out.x = (dx * delta + sx);
      out.y = (dy * delta + sy);

      return out;
    };
  },

  Random: function(separation, offsetDistance)
  {
    return function(start, end) 
    {
      var sx = start.x;
      var sy = start.y;
      var dx = end.x - sx;
      var dy = end.y - sy;
      var distance = Math.sqrt( dx * dx + dy * dy );
      var invdistance = 1.0 / distance;

      var points = [];

      points.push({
        x: sx,
        y: sy
      });

      var d = separation / 2;
      while (d < distance) 
      {
        var offsetX = Math.random() * offsetDistance * 2 - offsetDistance;
        var offsetY = Math.random() * offsetDistance * 2 - offsetDistance;
        var delta = d * invdistance;

        points.push({
          x: (dx * delta + sx) + offsetX,
          y: (dy * delta + sy) + offsetY
        });

        d += separation;
      }

      points.push({
        x: end.x,
        y: end.y
      });

      var pathDistances = [];
      var pathDistanceTotal = 0;

      for (var i = 0; i < points.length - 1; i++)
      {
        var p0 = points[ i + 0 ];
        var p1 = points[ i + 1 ];
        var pdx = p1.x - p0.x;
        var pdy = p1.y - p0.y;
        var pdist = Math.sqrt( pdx * pdx + pdy * pdy );

        pathDistanceTotal += pdist;
        pathDistances[ i ] = pathDistanceTotal;
      }

      return function(out, delta)
      {
        var v = delta * pathDistanceTotal;
        var minDistance = 0;
        var i = 0;

        while ( i < pathDistances.length - 1 && v > pathDistances[ i ] )
        {
          i++;
        }

        var minDistance = anim8.coalesce( pathDistances[ i - 1 ], 0 );
        var maxDistance = pathDistances[ i ];

        var pdelta = (v - minDistance) / (maxDistance - minDistance);
        var p0 = points[ i + 0 ];
        var p1 = points[ i + 1 ];

        out.x = (p1.x - p0.x) * pdelta + p0.x;
        out.y = (p1.y - p0.y) * pdelta + p0.y;

        return out;
      };
    };
  }
};